"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var INDEX_REGEX = /%s/g;
var NAMED_REGEX = /%\(\w+\)s/g;

function _default(fmt, obj, named) {
  var pattern = INDEX_REGEX;
  var transformer;

  function indexTransformer() {
    return String(obj.shift());
  }

  function objectTransformer(match) {
    return String(obj[match.slice(2, -2)]);
  }

  transformer = indexTransformer;

  if (named) {
    pattern = NAMED_REGEX;
    transformer = objectTransformer;
  }

  return String(fmt).replace(pattern, transformer);
}